/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function MegaphoneSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M220.47461,86.64062,138.395,62.70068l-.05127-.01513L44.47363,35.30664A15.99966,15.99966,0,0,0,23.99414,50.667V189.333A16.0247,16.0247,0,0,0,39.94922,205.3457a16.16154,16.16154,0,0,0,4.52539-.65234L128,180.332V192a16.01833,16.01833,0,0,0,16,16h32a16.01833,16.01833,0,0,0,16-16V161.665l28.47363-8.30469A16.0825,16.0825,0,0,0,231.99414,138V102A16.08075,16.08075,0,0,0,220.47461,86.64062ZM176,192H144V175.665l32-9.333Zm39.99414-54-34.35352,10.01953-.02832.0083L144,158.99805V81.00146L215.99414,102Z" />
    </Svg>
  );
}

export default MegaphoneSimple;
